import { useQueryClient } from '@tanstack/react-query'
import queryString from 'query-string'
import { TransactionsFiltersBody } from 'src/components/TransactionsListFilter/transactionsFilter.schema'
import { TransactionConnectedPlatformListResponse } from 'src/models/transaction.models'
import {
  MutationMethod,
  useExtendMutation,
  UseExtendMutationVariablesBody,
} from 'src/queries/queries.utils'
import { updateTransactionListResponses } from 'src/queries/transactions.queries'

interface PostPushTransactionsVariables
  extends UseExtendMutationVariablesBody<{
    transactionIds?: string[]
    bankAccountId: string
    pushAttachments?: boolean
  }> {
  organizationId: string
  connectionId: string
  connectedPlatformName: string
  filters?: TransactionsFiltersBody
}

interface PostPushTransactionsResponse {
  transactionConnectedPlatforms: TransactionConnectedPlatformListResponse[]
}

export const usePostPushTransactions = () => {
  const queryClient = useQueryClient()

  return useExtendMutation<
    PostPushTransactionsResponse,
    PostPushTransactionsVariables
  >(MutationMethod.POST, {
    mutationUrl: (variables) =>
      `/organizations/${variables.organizationId}/connections/${variables.connectionId}/push?${queryString.stringify({ ...variables?.filters })}`,
    onSuccess: (response) => {
      const transactionIds = response.transactionConnectedPlatforms.map(
        (transactionConnectedPlatform) =>
          transactionConnectedPlatform.transactionId,
      )
      updateTransactionListResponses(queryClient, {
        transactionIds: transactionIds,
        updater: (txn) => {
          const connectedPlatform = response.transactionConnectedPlatforms.find(
            (transactionConnectedPlatform) =>
              transactionConnectedPlatform.transactionId === txn.id,
          )
          return {
            ...txn,
            // connectedPlatform is never undefined because txn comes from transactionIds which is created from the same list response.transactionConnectedPlatforms
            // but the type checker doesn't know that, thus the undefined check
            connectedPlatforms: connectedPlatform
              ? [connectedPlatform]
              : undefined,
          }
        },
      })
    },
  })
}
